<template>
  <div class="CustomIcon">
    <svg
      class="CustomIcon__svg"
      width="0"
      height="0"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <clipPath
          :id="clipId"
          clipPathUnits="objectBoundingBox"
        >
          <path
            d="M0.5 0.01C0.769999 0.01 0.99 0.230001 0.99 0.5C0.99 0.769999 0.769999 0.99 0.5 0.99C0.230001 0.99 0.01 0.769999 0.01 0.5C0.01 0.230001 0.230001 0.01 0.5 0.01ZM0.5 0.25C0.356406 0.25 0.25 0.356406 0.25 0.5C0.25 0.643594 0.356406 0.75 0.5 0.75C0.643594 0.75 0.75 0.643594 0.75 0.5C0.75 0.356406 0.643594 0.25 0.5 0.25Z"
            fill-rule="evenodd"
          />
        </clipPath>
      </defs>
    </svg>
    <div
      class="CustomIcon__gradient"
      :style="{ clipPath: `url(#${clipId})` }"
    />
  </div>
</template>

<script setup>
const props = defineProps({
  id: { type: String, required: true },
})

const clipId = computed(() => `customIconShape-${props.id}`)
</script>

<style lang="postcss" scoped>
.CustomIcon {
  @apply relative w-full h-full block aspect-square;
}

.CustomIcon__gradient {
  @apply absolute inset-0;
  background: conic-gradient(
    from 0deg,
    rgba(136, 176, 145, 1) 0deg,
    rgba(255, 200, 62, 1) 45deg,
    rgba(245, 54, 202, 1) 135deg,
    rgba(61, 135, 221, 1) 225deg,
    rgba(23, 153, 225, 1) 316.8deg,
    rgba(136, 176, 145, 1) 360deg
  );
}
</style>
